export { OrderDetailsPage } from './src/ui/order-details-page';
